import { GENDERS } from "@/lib/constants";

export const genderLabel = (k) => GENDERS.find((g) => g.key === k)?.label || (k === "unknown" ? "Not given" : k);
// One fixed color per gender, so the same gender looks the same in every split.
const SHADE = { woman: "var(--cw-brand)", man: "var(--cw-on-surface)", nonbinary: "var(--cw-muted)", other: "var(--cw-on-brand-secondary)",
  prefer_not_to_say: "var(--cw-brand-secondary)", unknown: "var(--cw-border-strong)" };
const shade = (g) => SHADE[g] || SHADE.unknown;

// Stacked bar + legend for [{gender, count, pct}]. Shares above `max` are flagged.
export default function GenderSplit({ items = [], max, testId = "gender-split" }) {
  const total = items.reduce((n, g) => n + g.count, 0);
  if (!total) return <p className="cw-muted text-sm" data-testid={`${testId}-empty`}>No one yet.</p>;
  return (
    <div data-testid={testId}>
      <div className="flex h-2.5 overflow-hidden rounded-full bg-[var(--cw-surface-tertiary)]" aria-hidden>
        {items.map((g) => <span key={g.gender} style={{ width: `${g.pct}%`, background: shade(g.gender) }} />)}
      </div>
      <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm">
        {items.map((g) => (
          <li key={g.gender} className="flex items-center gap-2" data-testid={`${testId}-${g.gender}`}>
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: shade(g.gender) }} aria-hidden />
            <span>{genderLabel(g.gender)}</span>
            <span className={`tabular-nums ${max != null && g.pct > max ? "cw-error font-medium" : "cw-soft"}`}>{g.count} · {g.pct}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
